module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_U.b7314378.jpg";